// extracted by mini-css-extract-plugin
export default {"container":"AidForm_container__P7TnJ","column":"AidForm_column__E-fPV","btn":"AidForm_btn__2ldOI"};